<template>
  <v-card flat>
    <v-card-text class="pb-0">
      <v-container grid-list-md fluid class="ma-0 pa-0">
        <v-layout row wrap>
          <v-flex xs12 v-if="generalError">
            <v-alert color="error" icon="warning" dismissible v-model="generalError">
              {{ generalErrorMessage }}
            </v-alert>
          </v-flex>
          <!-- Asset Ids -->
          <v-flex md6>
            <v-combobox :label="messages.label.ASSET_ID" multiple chips append-icon="" clearable
              :error-messages="assetIdErrorMessages" required v-model="assetIds" :hint="messages.info.ASSET_ID_INFO"
              persistent-hint>
              <template slot="selection" slot-scope="data">
                <v-chip close :color="!isValidAssetId(data.item) ? 'red' : ''"
                  :text-color="!isValidAssetId(data.item) ? 'white' : ''" @input="removeAssetId(data.item)"
                  :selected="data.selected">
                  <strong>{{ data.item }}</strong>
                </v-chip>
              </template>
            </v-combobox>
          </v-flex>
          <!-- Providers -->
          <v-flex md4>
            <v-combobox v-model="selectedProviders" :label="messages.label.PROVIDER" class="mt-3" multiple hide-details
              :items="providersList">
            </v-combobox>
          </v-flex>
          <v-flex md2 class="text-xs-right">
            <v-btn color="primary" class="mt-3" @click="searchAssets()">
              {{ messages.label.SEARCH }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import axios from "axios"
import XMLBacklogService from "@/XMLBacklog/XMLBacklogService"
import * as utils from "@/Shared/utils"
import messages from "@/XMLBacklog/messages.json"

export default {
  name: "XMLBacklogSearchFilter",
  data() {
    return {
      selectedProviders: [],
      providersList: [],
      assetIds: [],
      forceAssetIdValidation: false,
      generalError: false,
      generalErrorMessage: ""
    }
  },
  methods: {
    /**
     * Remove asset id from the list
     */
    removeAssetId(item) {
      this.assetIds.splice(this.assetIds.indexOf(item), 1)
      this.assetIds = [...this.assetIds]
    },
    /**
     * Validate if given value is a valid AssetID
     * AssetID format : 4 Chars followed by 16 Numerals
     */
    isValidAssetId(value) {
      let assetIdRegEx = new RegExp("^[a-zA-Z]{4}[0-9]{16}$")
      let isValid = assetIdRegEx.test(value)
      return isValid
    },
    /**
     * Begin to search for assets
     */
    searchAssets() {
      let searchParams = {
        assetIds: this.assetIds.filter(this.isValidAssetId),
        providers: this.selectedProviders
      }
      // Force validating
      this.forceAssetIdValidation = true
      if (this.assetIdErrorMessages.length === 0) {
        XMLBacklogService.$emit("event:assetSerach", searchParams)
      }
    },
    /**
     * Retreive providers
     * httpStatus                statusCode statusMessage                         message
     * ------------------------- ---------- ------------------------------------- ---------------------------
     * 200 OK                    0
     * 404 Not Found             1001200    No providers found
     * 500 INTERNAL_SERVER_ERROR 1000100    Error                                 (various errors)
     * 503 SERVICE_UNAVAILABLE   1001100    Error accessing database              (various DB errors)
     * 503 SERVICE_UNAVAILABLE   1000700    Unable to access system               (various network errors)
     */
    retrieveProviders() {
      let providersURI =
        utils.getServerUrl() + "/api/xml-backlog/providers"
      axios
        .get(providersURI)
        .then((response) => {
          this.generalError = false
          this.generalErrorMessage = ""
          this.providersList = response.data.data.providers
        })
        .catch(() => {
          this.providersList = []
          this.generalError = true
          this.generalErrorMessage = messages.error.NO_PROVIDERS
        })
    }
  },
  computed: {
    /**
     * Returns error messages to be displayed if Asset ID is invalid
     */
    assetIdErrorMessages() {
      let errors = []
      let validAssetIds = this.assetIds.filter(this.isValidAssetId)
      if (this.forceAssetIdValidation) {
        if (this.assetIds.length === 0 || validAssetIds.length === 0) {
          errors.push(this.messages.validation.VALID_ASSET_ID_REQUIRED)
        } else {
          errors = []
          this.forceAssetIdValidation = false
        }
      } else if (this.assetIds.length > 0 && validAssetIds.length === 0) {
        errors.push(this.messages.validation.VALID_ASSET_ID_REQUIRED)
      }

      return errors
    }
  },
  created() {
    /**
     * Non reactive properties
     */
    this.messages = messages
    /**
     * Initialization
     */
    this.retrieveProviders()
  }
}
</script>



// WEBPACK FOOTER //
// src/XMLBacklog/XMLBacklogSearchFilter.vue